import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-top",
  "use": "app-icon-arrow-top-usage",
  "viewBox": "0 0 16 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 10\" id=\"app-icon-arrow-top\"><path d=\"M8 .67l7.24 7.25-1.41 1.41L8 3.5 2.17 9.33.76 7.92z\" fill=\"#1B8ADB\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol